import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic } from 'src/store';
import { of } from 'rxjs';
import { receiveViewDefns, updateGroupBy } from 'src/components/Subheader/Subheader.slice';
import { getGroupBy } from 'src/components/Subheader/Subheader.selectors';
import { fetchCanvasViewData, cleanUp } from './CanvasView.slice';
import {
  inputIsNotNullOrUndefined,
  isSameComponentType,
  isScopeDefined,
  isSubheaderLoaded,
  maybeGetComponentProps,
} from 'src/utils/Functions/epicsFunctions';
import { ConfDefnComponentType, CanvasViewComponent } from 'configuration-schemas/confdefnComponents';
import { isListDataApi } from 'configuration-schemas/confdefnView';
import { ExtraPivotOptions, getAggBys, organizeListDataOptions } from '../StyleColorReview.slice';
import {
  receiveScopeConfig,
  receiveScopeRefreshTrigger,
} from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { updateSelectedItem } from 'src/pages/Worklist/Worklist.slice';
import { setActivePage, setActiveSubPage } from 'src/pages/NavigationShell/NavigationShell.slice';
import { LENS_ASST_PLAN_REFRESHING_PAGE } from 'src/pages/AssortmentBuild/Planning.types';
import { REQUEST_EXTERNAL_DATA_REFRESH } from 'src/components/higherOrder/GlobalDataRefresh';

export const canvasViewLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      REQUEST_EXTERNAL_DATA_REFRESH,
      receiveFilterStateAfterSubmission.type,
      setActivePage.type,
      setActiveSubPage.type,
      updateSelectedItem.type,
      updateGroupBy.type,
      'LENS_CanvasView: Config loaded',
      receiveScopeConfig.type,
      LENS_ASST_PLAN_REFRESHING_PAGE,
      receiveViewDefns.type,
      REQUEST_EXTERNAL_DATA_REFRESH,
    ),
    map(() => maybeGetComponentProps<CanvasViewComponent>(state$.value, ConfDefnComponentType.canvasView)),
    filter(inputIsNotNullOrUndefined),
    filter(() => isScopeDefined(state$.value.scope) && isSubheaderLoaded(state$.value.subheader)),
    mergeMap(({ defns }) => {
      const { dataApi, model: modelDefn } = defns;
      const finalModelDefn = isListDataApi(dataApi) ? dataApi.defnId : modelDefn;

      const aggBy = getAggBys(getGroupBy(state$.value), dataApi);
      const options: ExtraPivotOptions = { aggBy };
      const finalOptions = organizeListDataOptions(options, dataApi);

      if (isSameComponentType<CanvasViewComponent>(state$.value, ConfDefnComponentType.canvasView)) {
        return of(cleanUp(), fetchCanvasViewData(finalModelDefn, finalOptions));
      }

      return of(fetchCanvasViewData(finalModelDefn, finalOptions));
    }),
  );
};
